import { MdDocumentScanner } from "react-icons/md";

const GeneratingDocuments = () => {
  return (
    <div className="lf-subscription" key="form_area">
      <div className="lf-subscription__container">
        <div className="lf-subscription-done__header">
          <div className="lf-subscription-done__icon-wrapper">
            <MdDocumentScanner size={48} color="#bac7d3" />
          </div>
          <p className="lf-subscription-done__description">
            Géneration des documents en cours...
          </p>
        </div>
      </div>
    </div>
  );
};

export default GeneratingDocuments;
